import { Badge } from "@/components/ui/badge";
import { cn } from "@/lib/utils";

type StatusType =
  | "pending"
  | "confirmed"
  | "in_progress"
  | "completed"
  | "delivered"
  | "cancelled"
  | "draft"
  | "accepted"
  | "rejected";

interface StatusBadgeProps {
  status: StatusType;
  className?: string;
}

const statusConfig: Record<
  StatusType,
  { label: string; variant: "default" | "secondary" | "destructive" | "outline"; className: string }
> = {
  pending: {
    label: "Pending",
    variant: "secondary",
    className: "bg-yellow-100 text-yellow-800 border-yellow-200",
  },
  confirmed: {
    label: "Confirmed",
    variant: "default",
    className: "bg-blue-100 text-blue-800 border-blue-200",
  },
  in_progress: {
    label: "In Progress",
    variant: "default",
    className: "bg-primary/10 text-primary border-primary/20",
  },
  completed: {
    label: "Completed",
    variant: "default",
    className: "bg-green-100 text-green-800 border-green-200",
  },
  delivered: {
    label: "Delivered",
    variant: "default",
    className: "bg-emerald-100 text-emerald-800 border-emerald-200",
  },
  cancelled: {
    label: "Cancelled",
    variant: "destructive",
    className: "bg-red-100 text-red-800 border-red-200",
  },
  draft: {
    label: "Draft",
    variant: "outline",
    className: "bg-gray-100 text-gray-700 border-gray-300",
  },
  accepted: {
    label: "Accepted",
    variant: "default",
    className: "bg-green-100 text-green-800 border-green-200",
  },
  rejected: {
    label: "Rejected",
    variant: "destructive",
    className: "bg-red-100 text-red-800 border-red-200",
  },
};

export function StatusBadge({ status, className }: StatusBadgeProps) {
  const config = statusConfig[status];

  return (
    <Badge
      variant={config.variant}
      className={cn(config.className, "font-medium", className)}
    >
      {config.label}
    </Badge>
  );
}
